export var CREDENTIALS = {
    include: 'include',
    default: 'same-origin',
};
